import React from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { Dialog, Tooltip } from '@mui/material';
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg"
import moment from 'moment';
import "../../style.scss";
import { statusMapping, statusStyle } from 'modules/studentRefund/refundApproval/view/constant';
import { getHeaderChipInfo } from 'modules/paymentManagement/cashApproval/view/constant';
import CustomChip from 'views/pages/manage/common/customChip/CustomChip';
import styles from "../../../paymentManagement.module.scss";
import { CHEQUE_HEADER_CHIPS_CONFIG } from '../../shared/constant';
import IconButtonWrapper from 'views/pages/manage/common/form-fields-mui/IconButtonWrapper';

const ChequeDateExtensionLogs = ({
    setShowModelInfo,
    showModelInfo
}) => {
    // const [rows, setRows] = useState(rowList)
    // const [currentPage, setCurrentPage] = useState(0);

    const handleCloseDialog = () => {
        setShowModelInfo(false);
    }



    const columns = [
        new AGridColDef("action", "Events", false)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? (
                    <div className='d-flex align-items-center'>
                        <Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container `} >
                                {params?.value}
                            </div>
                        </Tooltip>
                        <Tooltip title={'View Receipt Id'}>
                            <div className={`ellipsis-text-container`} >
                                {/* <ViewReceiptId rowData={params?.row} /> */}
                            </div>
                        </Tooltip>
                    </div>
                ) : (
                    <div>-</div>
                )
            )),

        new AGridColDef("updatedOn", "Updated On", true)
            .setMinWidth(130)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')} by ${params.row.updatedBy} `}>
                    <div className={`ellipsis-text-container`}>{`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')}  ${params?.row?.updatedBy ? `by ${params?.row?.updatedBy}` : ''}`}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("status", "Status", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(0.50)
            .columnAlign('right')
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={statusMapping?.[(params?.value).toUpperCase()] ?? (params?.value).toUpperCase()}>
                    <div className={`ellipsis-text-container`} style={statusStyle?.[statusMapping?.[(params?.value).toUpperCase()]]}>{statusMapping?.[(params?.value).toUpperCase()] ?? (params?.value).toUpperCase()}</div>
                </Tooltip> : <div>-</div>
            ))

    ]

    return (
        <Dialog
            open={showModelInfo}
            maxWidth={false}
            PaperProps={{ sx: { borderRadius: "12px" } }}
        >
            <div className="cheque-date-extension-logs-popup">
                <div className="d-flex " style={{ justifyContent: "space-between" }}>
                    <div className="heading-4 color-dark">Logs </div>

                    <div className={`${styles['headerChips']} ml-2`}>
                        {CHEQUE_HEADER_CHIPS_CONFIG.map((item) => (
                            <CustomChip
                                key={item?.key}
                                className={styles['headerChip']}
                                {...getHeaderChipInfo({
                                    label: item?.label,
                                    value: item?.render?.(showModelInfo?.headerDetails?.[item?.key]) || showModelInfo?.headerDetails?.[item?.key],
                                    chipType: item?.chipType,
                                    styles
                                })}
                            />
                        ))}
                    </div>
                    <IconButtonWrapper onClick={handleCloseDialog}>
                        <CrossIcon/>
                    </IconButtonWrapper>
                </div>
                <ADataGrid
                    removeWrapperContainer
                    // rowModesModel={rowModesModel}
                    rows={showModelInfo?.rowList || []}
                    columns={columns}
                    rowId={(row) => JSON.stringify(row)}
                    rowHeight={50}
                    loading={false}
                    rowCount={showModelInfo?.rowList?.length || 0}
                    components={{
                        ...gridComponents,
                        // NoRowsOverlay: () => (
                        //     <NoRowOverlay message={loader ? "Loading..." : null} />
                        // ),
                    }}
                    sx={gridStyles}
                    //  pageSize={10}
                    serverPagination={false}
                    autoHeight
                    pinLastColumn
                    hidePagination={true}
                />

            </div>
        </Dialog>


    )
}

export default ChequeDateExtensionLogs